<div (click)="onClick()" class="ui card full-width hand">
    <div class="content">
        <div class="left floated">
            <img class="brand-logo" src="{{brandUrl}}">
            <div class="car-brand-container">
                <p class="car-brand">{{occasion.getBrandAsString()}}</p>
            </div>

        </div>
        <div class="right floated meta align">
            {{occasion.date.toLocaleDateString()}}
        </div>
    </div>
    <div class="image">
        <img src="{{occasion.picture}}">
    </div>
    <div class="content">
        <a class="header">{{occasion.name}}</a>
        <div class="ui two column grid">
            <div class="column">
                <p>{{occasion.getGasolineAsString()}}</p>
                <p>{{occasion.getGearboxAsString()}}</p>
            </div>
            <div class="column">
                <p class="text-right">{{occasion.price}} €</p>
                <p class="text-right">{{occasion.mileage}} km</p>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/occasions/content/occasions-light/occasions-light.html